<template>
    <div>
        <vacations-table :sortable="false" class="mt-2"
           icon="mdi-briefcase-remove"
           hide-subtitle
           hide-actions
           @refresh="getItems"
           color="indigo darken-1"
           :total="total"
           :items="items"
           :append-headers="appendHeaders">
            <template slot="items" slot-scope="{ item }">
                <td class="text-xs-right">
                    <v-tooltip top>
                        <v-btn slot="activator" class="mx-0" small flat icon color="tertiary lighten-2" :to="'/vacation-requests/' + item.id + '/show'">
                            <v-icon  small>mdi-eye-settings</v-icon>
                        </v-btn>
                        <span>{{$t('Core.Fields.show')}}</span>
                    </v-tooltip>
                </td>
            </template>
        </vacations-table>
    </div>
</template>

<script>
    import _ from 'lodash';
    import VacationsTable from '../vacationRequests/Table'
    import i18n from '@/i18n'
    export default {
    components: {VacationsTable},
    props: {
      id: {
          type: String,
          required: true
      }
    },
    data: () => ({
        total: 0,
        pagination: {},
        items: [],
        appendHeaders: [
            {
                sortable: false,
                text: i18n.t('Core.Fields.actions'),
                value: 'actions',
                align: 'right'
            },
        ]
    }),
    computed: {

    },
    created () {

    },
    methods: {
        getItems(data = null){
            this.pagination = data;
            if(this.initial){
                this.setFetching(true);
            }
            this.loading = true;
            data.include = 'user,vacationType,collectiveVacation';

            if(this.id != -1) {
                this.repositories.user.paginatedVacationRequests(this.id, data).then(response => {
                    this.items = response.data.data;
                    this.total = response.data.meta.pagination.total;
                }).finally(() => {
                    this.loading = this.initial = false;
                    this.setFetching(false);
                });
            }
            else{
                this.repositories.user.myPaginatedVacationRequests(data).then(response => {
                    this.items = response.data.data;
                    this.total = response.data.meta.pagination.total;
                }).finally(() => {
                    this.loading = this.initial = false;
                    this.setFetching(false);
                });
            }
    },


    }
}
</script>

<style lang="scss">

</style>
